import { cn } from "@/lib/utils";

type Unidad = "ha" | "m2";

const OPCIONES: { valor: Unidad; etiqueta: string }[] = [
  { valor: "ha", etiqueta: "Hectáreas (ha)" },
  { valor: "m2", etiqueta: "Metros (m²)" },
];

/**
 * La unidad de superficie del informe como control segmentado de dos
 * posiciones, junto a «Agregar rol» (diseño v2).
 *
 * Es un `radiogroup`: lo que se elige es UNA unidad para el informe entero,
 * y su valor es el mismo `unidad_superficie` que antes elegía un `Select`.
 */
export function SegmentoDeUnidad({
  value,
  onChange,
}: {
  value: Unidad;
  onChange: (valor: Unidad) => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-ink-hint text-[0.6875rem] font-bold">Unidad</span>
      <div
        role="radiogroup"
        aria-label="Unidad de superficie"
        className="bg-muted flex h-9 items-stretch gap-[3px] rounded-md p-[3px]"
      >
        {OPCIONES.map(({ valor, etiqueta }) => (
          <button
            key={valor}
            type="button"
            role="radio"
            aria-checked={value === valor}
            onClick={() => onChange(valor)}
            className={cn(
              "focus-visible:ring-ring/50 flex items-center rounded-sm px-2.5 text-xs whitespace-nowrap outline-none focus-visible:ring-[3px]",
              value === valor
                ? "bg-card text-ink font-bold shadow-sm"
                : "text-ink-muted font-semibold",
            )}
          >
            {etiqueta}
          </button>
        ))}
      </div>
    </div>
  );
}
